// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__35daz","breadcrumb":"Breadcrumbs_breadcrumb__3h_Mq"};